export default __webpack_public_path__ + "static/media/laporan-kasir.335afaf9.png";